<template>
  <f7-actions :class="`${actionsOpenName}`">
    <f7-actions-group>
      <f7-actions-button color="blue" @click="()=>handleShare(userId, cityId)">Share to...</f7-actions-button>
      <f7-actions-button color="blue">
        <f7-link
          v-clipboard:copy="`${constants.DOMAIN_SHARE.DOMAIN + '/' + constants.TYPE_URL.PASSPORT + '/' + userId + '/' + cityId}`"
          v-clipboard:success="onCopySuccess"
          v-clipboard:error="onCopyError"
        >Copy Link</f7-link>
      </f7-actions-button>
      <input
        type="hidden"
        :v-model="`${constants.DOMAIN_SHARE.DOMAIN + '/' + constants.TYPE_URL.PASSPORT + '/' + userId + '/' + cityId}`"
      >
    </f7-actions-group>
    <f7-actions-group>
      <f7-actions-button color="blue" bold>Cancel</f7-actions-button>
    </f7-actions-group>
  </f7-actions>
</template>
<script>
import C from "../_helpers/constants";
import { shareMagazine } from "../utils/share";
import { copySuccess, copyError } from "../utils/copy";
export default {
  props: {
    actionsOpenName: {
      required: false,
      type: String
    },
    userId: {
      required: false,
      type: String
    },
    cityId: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      constants: C
    };
  },
  methods: {
    handleShare(userId, cityId) {
      return shareMagazine(userId, cityId);
    },
    onCopySuccess(e) {
      return copySuccess(e, this);
    },
    onCopyError(e) {
      return copyError(e);
    }
  }
};
</script>

